<template>
  <v-list id="js-nav-menu-list" :dense="false">
    <v-list-item @click="$router.push({ name: 'dashboardManager' })">
      <v-list-item-icon>
        <v-icon>mdi-home</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span>Home</span>
      </v-list-item-content>
    </v-list-item>

    <v-list-item @click="$router.push({ name: 'coursesGridManager' })">
      <v-list-item-icon>
        <v-icon>mdi-school</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span>Learning Resources</span>
      </v-list-item-content>
    </v-list-item>

    <v-list-item @click="$router.push({ name: 'documentsListManager' })">
      <v-list-item-icon>
        <v-icon>mdi-file-document-box-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span>Documents</span>
      </v-list-item-content>
    </v-list-item>

    <v-list-item
      v-if="this.isPresident()"
      @click="$router.push({ name: 'admin' })"
    >
      <v-list-item-icon>
        <v-icon>mdi-gavel</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <span>Admin</span>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import User from "@/lib/user"
import { UsersAPI } from "@/lib/api"

export default {
  methods: {
    isPresident: function() {
      return User.isPresident()
    }
  }
}
</script>
